export default __webpack_public_path__ + "static/media/logo.12e36862.png";